var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "create_dialog",
          attrs: {
            visible: _vm.isOpen,
            "show-close": true,
            "before-close": _vm.handleClose,
            top: "15px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpen = $event
            },
          },
        },
        [
          _c("div", { staticClass: "body_dialog" }, [
            _c("div", { staticClass: "survey_form" }, [
              _c(
                "section",
                { staticClass: "wrap_image_form radius border" },
                [
                  _c("el-image", {
                    staticClass: "main_image",
                    attrs: { src: _vm.defaultDataForm.imgWeb },
                  }),
                ],
                1
              ),
              _c(
                "section",
                {
                  staticClass: "header_survey_form radius border element_form",
                },
                [
                  _c("div", { staticClass: "header_survey_title" }, [
                    _c("span", [_vm._v(_vm._s(_vm.defaultDataForm.title))]),
                  ]),
                  _c("div", { staticClass: "header_survey_description" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.defaultDataForm.description) +
                        "\n          "
                    ),
                  ]),
                ]
              ),
              _c(
                "section",
                { ref: "wrapQuestion", staticClass: "wrap_question" },
                _vm._l(
                  _vm.defaultDataForm.questionResponseList,
                  function (question, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        ref: `elementForm-${index}`,
                        refInFor: true,
                        staticClass: "radius border element_form",
                        on: {
                          click: function ($event) {
                            return _vm.handleElementClick(index)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "element_body" },
                          [
                            _c(
                              "el-row",
                              { attrs: { type: "flex", gutter: 14 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "element_question" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "question_title" },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(question.questionText) +
                                              "\n                      "
                                          ),
                                          question.obligatory
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [_vm._v("*")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      question.typeQuestion === "Text"
                                        ? _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "Văn bản trả lời",
                                              maxlength: 500,
                                              "show-word-limit": true,
                                              rows: 3,
                                              disabled: true,
                                              autosize: {
                                                minRows: 3,
                                                maxRows: 6,
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      question.typeQuestion === "CheckBox"
                                        ? _c(
                                            "div",
                                            { staticClass: "wrap_checkbox" },
                                            _vm._l(
                                              question.valueQuestionArray,
                                              function (item, indexOption) {
                                                return _c(
                                                  "el-checkbox",
                                                  {
                                                    key: indexOption,
                                                    staticClass:
                                                      "container_checkbox",
                                                    attrs: {
                                                      disabled: true,
                                                      label: item.value,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          color: "#000",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(item.value) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                      question.typeQuestion === "Radio"
                                        ? _c(
                                            "div",
                                            { staticClass: "wrap_checkbox" },
                                            _vm._l(
                                              question.valueQuestionArray,
                                              function (item, index) {
                                                return _c(
                                                  "el-radio",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "container_checkbox",
                                                    attrs: {
                                                      disabled: true,
                                                      label: item.value,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display:
                                                            "inline-block",
                                                          color: "#000",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(item.value) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                      question.typeQuestion === "Point"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "padding-left": "14px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "0 16px",
                                                  },
                                                },
                                                _vm._l(
                                                  10,
                                                  function (item, index) {
                                                    return _c(
                                                      "div",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              display: "flex",
                                                              "justify-content":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "option_point",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      question.typeQuestion === "Star"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "padding-left": "14px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "0 16px",
                                                  },
                                                },
                                                _vm._l(5, function (item) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key: item,
                                                      staticClass: "icon_star",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-star-off",
                                                      }),
                                                    ]
                                                  )
                                                }),
                                                0
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }
                ),
                0
              ),
            ]),
          ]),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "div",
              { staticStyle: { padding: "10px 0" } },
              [
                _c(
                  "el-button",
                  { attrs: { type: "danger" }, on: { click: _vm.handleClose } },
                  [
                    _c("i", { staticClass: "el-icon-circle-close" }),
                    _vm._v("\n          Đóng\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }